import React from "react";
import ReactDOM from "react-dom/client";
// 화면이 그려지기 전에 i18next 가 초기화되어야 합니다. 부수효과만 있는 import 라
// 이름을 받지 않습니다.
import "./i18n";
import "./styles/global.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// React 18 이상
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && args[0].includes && args[0].includes('findDOMNode is deprecated')) {
    return;
  }
  originalConsoleError(...args);
};
